import { CriarCheckboxDeRastreaveis } from '../../componentes/criarCheckboxDeRastreaveis';
import { CriarCheckboxDeClientes } from '../../componentes/criarCheckboxDeClientes';
import { AxiosConfig } from '../../componentes/axiosConfig';


export class ExibirClientesERastreaveis {
    constructor() {
        this._checkboxClientes       = new CriarCheckboxDeClientes();
        this._checkboxRastreaveis    = new CriarCheckboxDeRastreaveis();
        this._axios                  = (new AxiosConfig()).instanciaAxios();
        this._idDivExibirRastreaveis = 'containner-exibir-rastreaveis';
        this._idCarregarRastreaveis  = 'carregar-rastreaveis-usuario-adm';

        this._idCarregarClientes     = 'carregar-clientes-usuario-adm';
        this._idDivExibirClientes    = 'containner-exibir-clientes';
    }

    /**
     * Deve ser executado apenas na tela onde o usuário administrativo
     * é atualizado.
     *
     * @returns {void}
     */
    telaAtualizarCarregarClientes() {
        const telaAtualizar     = document.getElementById('form-usuarios-cliente-atualizar');
        const carregarclientes  = document.getElementById(this._idCarregarClientes);
        const clientesDoUsuario = this._clientesAssociadosAoUsuario();
        if (!telaAtualizar || !carregarclientes || clientesDoUsuario.length === 0) {
            return;
        }

        carregarclientes.click();
        $('#collapse_1').collapse();
        carregarclientes.classList.add('activestate');
    }

    /**
     * Deve ser executado apenas na tela onde o usuário administrativo
     * é atualizado.
     *
     * @returns {void}
     */
    telaAtualizarCarregarRastreaveis() {
        const telaAtualizar        = document.getElementById('form-usuarios-cliente-atualizar');
        const carregarRastreaveis  = document.getElementById(this._idCarregarRastreaveis);
        const rastreaveisDoUsuario = this._rastreaveisAssociadosAoUsuario();
        if (!telaAtualizar || !carregarRastreaveis || rastreaveisDoUsuario.length === 0) {
            return;
        }

        $('#collapse_2').collapse();
        carregarRastreaveis.classList.add('activestate');

        const containnerExibirRastreaveis = document.getElementById(this._idDivExibirRastreaveis);
        const clientesQueUsuarioTemAcesso = this._clientesAssociadosAoUsuario();

        this._checkboxRastreaveis
        .selecionarCheckbox(this._rastreaveisAssociadosAoUsuario())
        .criar(containnerExibirRastreaveis, clientesQueUsuarioTemAcesso);
    }

    /**
     * Será criado uma lista com todos os clientes da empresa.
     *
     * @returns {void}
     */
    telaCriarCarregarClientes() {
        const carregarclientes = document.getElementById(this._idCarregarClientes);
        if(carregarclientes === null){
            return;
        }

        carregarclientes.addEventListener('click', () => {
            if (carregarclientes.classList.contains('activestate') === false) {
                const containnerExibirClientes = document.getElementById(this._idDivExibirClientes);
                this._checkboxClientes
                .selecionarCheckbox(this._clientesAssociadosAoUsuario())
                .criar(containnerExibirClientes);
            }
        });
    }

    /**
     * Executado ao cadastrar ou atualizar um usuário administrativo.
     */
    telaCriarCarregarRastreaveisDosClientesSelecionados() {
        const carregarRastreaveis = document.getElementById(this._idCarregarRastreaveis);
        if(carregarRastreaveis === null){
            return;
        }

        carregarRastreaveis.addEventListener('click', () => {
            if (carregarRastreaveis.classList.contains('activestate')) {
                return;
            }

            const clientes = this._obterClientesSelecionados();
            const containnerExibirRastreaveis = document.getElementById(this._idDivExibirRastreaveis);
            if (clientes.length === 0) {
                containnerExibirRastreaveis.innerHTML = 'Primeiro você precisa selecionar os clientes';
                return;
            }

            this._checkboxRastreaveis
            .selecionarCheckbox(this._rastreaveisAssociadosAoUsuario())
            .criar(containnerExibirRastreaveis, clientes);
        });
    }

    /**
     * No HTML deve existir uma div com a propriedade "data-clientes-id", essa propriedade
     * recebe um array contendo os clientes que o usuário tem acesso.
     *
     * @returns {int[]} um array contendo os id dos clientes que o usuário tem acesso
     * @private
     */
    _clientesAssociadosAoUsuario() {
        const clientesDoUsuario = document.getElementById('clientes-do-usuario');
        if (!clientesDoUsuario || !clientesDoUsuario.dataset.clientesId) {
            return [];
        }

        let resposta = JSON.parse(clientesDoUsuario.dataset.clientesId);
        if (Array.isArray(resposta) && resposta.length > 0) {
            resposta = resposta.map((valorString) => {
                return parseInt(valorString);
            })
        }

        return Array.isArray(resposta) ? resposta : [];
    }

    /**
     * No HTML deve existir uma div com a propriedade "data-rastreaveis-id", essa propriedade
     * recebe um array contendo os rastreáveis que o usuário tem acesso.
     *
     * @returns {int[]} um array contendo os id dos rastreáveis que o usuário tem acesso
     * @private
     */
    _rastreaveisAssociadosAoUsuario() {
        const rastreaveisDoUsuario = document.getElementById('rastreaveis-do-usuario');
        if (!rastreaveisDoUsuario || !rastreaveisDoUsuario.dataset.rastreaveisId) {
            return [];
        }

        let resposta = JSON.parse(rastreaveisDoUsuario.dataset.rastreaveisId);
        if (Array.isArray(resposta) && resposta.length > 0) {
            resposta = resposta.map((valorString) => {
                return parseInt(valorString);
            })
        }

        return Array.isArray(resposta) ? resposta : [];
    }

    /**
     * @returns {array}
     */
    _obterClientesSelecionados() {
        const checkbox = document.querySelectorAll('input[name="clientes[]"]:checked');
        const clientes = Array.from(checkbox).map(objeto => objeto.value);

        return clientes;
    }
}
